import { Component } from '@angular/core';

@Component({
  selector: 'app-product-weight',
  standalone: false,
  
  templateUrl: './product-weight.component.html',
  styles: ``
})
export class ProductWeightComponent {

}
